<template>
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :other-params="{
          taskId:taskId
        }"
        :height="600"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
    >
      <template v-slot:operate="{row}">
        <div>
          <a-avatar :src="row.headImg"/>
        </div>
      </template>
    </x-grid>


  </div>
</template>

<script>
import {
  GridMixin,
  api,
  fac,
} from "@/utils/common/XGridBase"


//列表接口
const url = api.operate.MASS_SEND_WORK + '/wxMsgTaskLog';

//主键
const rowId = 'logId';

//列
const columns = [
  fac.makeColumn({
    field: "headImg",
    title: "用户头像",
    width: 140,
    align: 'center',
    slots: {default: 'default'}
  }),
  fac.makeColumn("userName", "用户姓名", 160),
  fac.makeColumn("userId", "用户账号", 160),
  fac.makeColumn("publishStatusName", "发表状态", 140, 'center')
]

//筛选项
const formConfig = fac.makeFormConfig(columns, [
  {field: 'userId'},
])

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: true,
  delData: false,
  addData: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);


export default {
  mixins: [GridMixin],
  props: {
    taskId: {
      default: '',
    },
  },
  data() {
    return {
      columns,
      rowId,
      url,
      exportUrl: api.operate.MASS_SEND_WORK + '/wxMsgTaskLog/exportExcel?taskId=' + this.taskId,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
    }
  },
  async mounted() {
  },
  methods: {}
}
</script>

<style scoped>
</style>